export interface ISalonAddressData {
  salonCity: string;
  salonStreet: string;
  salonHouseNumber: string;
  salonHouseSubNumber: string;
}
